/**
 * O selo do juízo da custódia (F-E144.F4-01), na consulta "Cadeia de custódia" (desde a E165, a
 * custódia saiu do Enviar e do Conferir, ADR-0114 §3): ainda não conferida, divergência ou o
 * resultado compatível com os registros — que o HTML 6.7 chama de "Aderente com limitações", porque
 * o alcance é só desde o recebimento.
 */
import { Badge } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { ReciboDaCustodiaData } from '@/lib/abertura_do_caso';

import { estadoDaCustodia, type EstadoDaCustodia } from './estadoDaCustodia';

const t = ptBR.abertura.custodia.seloDaCadeia;

const SELO: Record<
  EstadoDaCustodia['tipo'],
  { variant: 'neutral' | 'danger' | 'info'; texto: string }
> = {
  sem_conferencia: { variant: 'neutral', texto: t.semConferencia },
  divergencia: { variant: 'danger', texto: t.divergencia },
  compativel: { variant: 'info', texto: t.aderente },
};

export function SeloDaCustodia({
  recibo,
  testId,
}: {
  recibo: ReciboDaCustodiaData;
  testId: string;
}): JSX.Element {
  const selo = SELO[estadoDaCustodia(recibo).tipo];
  return (
    <Badge variant={selo.variant} data-testid={testId}>
      {selo.texto}
    </Badge>
  );
}
